var React = require('react');

function ServiceIcon (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"serviceIcon"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"serviceIcon","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},[React.createElement("polygon",{"id":"Path-16","fill":"#FFFFFF","points":"4 9 16 14.5 28 9 16 3.5","key":0}),React.createElement("polygon",{"id":"Path-17","fill":"#FFFFFF","points":"4 11 4 24.2 15 29 15 16","key":1}),React.createElement("polygon",{"id":"Path-18","fill":"#FFFFFF","points":"17 16 17 29 28 24 28 11","key":2})])]);
}

ServiceIcon.defaultProps = {"width":"32px","height":"32px","viewBox":"0 0 32 32","version":"1.1"};

module.exports = ServiceIcon;

ServiceIcon.default = ServiceIcon;
